module.exports = __webpack_public_path__ + "img/youxi@3x.41f1a52f.png";